export const GET_PM_NODES = 'GET_PM_NODES'
export const SET_PM_NODES_ERROR = 'SET_PM_NODES_ERROR'
export const SET_PM_NODES_PROCESSING = 'SET_PM_NODES_PROCESSING'
export const SET_PM_NODES = 'SET_PM_NODES'
export const SET_PM_NODE = 'SET_PM_NODE'
export const GET_PM_NODE = 'GET_PM_NODE'
export const SET_PM_NODE_PROCESSING = 'SET_PM_NODE_PROCESSING'
export const UPDATE_PM_NODES_SUCCESS = 'UPDATE_PM_NODES_SUCCESS'

export function getPmNode (payload) {
  return {
    type: GET_PM_NODE,
    payload,
  }
}

export function setPmNode (payload) {
  return {
    type: SET_PM_NODE,
    payload,
  }
}

export function getPmNodes (payload) {
  return {
    type: GET_PM_NODES,
    payload,
  }
}

export function setPmNodes (payload) {
  return {
    type: SET_PM_NODES,
    payload,
  }
}

export function setPmNodeProcessing (payload) {
  return {
    type: SET_PM_NODE_PROCESSING,
    payload,
  }
}

export function setPmNodesProcessing (payload) {
  return {
    type: SET_PM_NODES_PROCESSING,
    payload,
  }
}

export function setPmNodesError (payload) {
  return {
    type: SET_PM_NODES_ERROR,
    payload,
  }
}
